module.exports = __webpack_public_path__ + "img/tool_responsive_black.60941d67.png";